import { useCallback } from 'react';

import { usePostCustomerCreditors } from 'api';

import { useOrganisationId } from 'hooks/context';

import { useDraftDefinition } from '../contexts/DraftDefinitionProvider';
import { useDraftProgress } from '../contexts/DraftProgressProvider';
import { extractReceiverInformation } from '../utils/extractReceiverInformation';

export const useSaveReceiver = () => {
  const { data } = useDraftProgress();
  const { product } = useDraftDefinition();
  const { mutate: createCustomerCreditor } = usePostCustomerCreditors();
  const organisationId = useOrganisationId<number>();

  const saveCreditorDetails = useCallback(() => {
    const receiver = extractReceiverInformation(data);

    if (receiver === null) {
      return;
    }

    const creditor = {
      ...receiver,
      product_id: Number(product.product_id),
      schema_id: Number(product.schema_id)
    };

    return createCustomerCreditor({
      data: { creditor },
      organisationId
    });
  }, [
    createCustomerCreditor,
    data,
    organisationId,
    product.product_id,
    product.schema_id
  ]);

  return saveCreditorDetails;
};
